import { Grid, useMediaQuery, useTheme } from '@mui/material'

import { TableView } from './table-view.component'
import { ListView } from './list-view.component'
import { RedirectButton } from './redireact-button.component'
import { useHealthCheck } from 'src/hooks'

interface IProps {
  withoutRedirect?: boolean
}

export const HealthCheckList = ({ withoutRedirect }: IProps) => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const { data } = useHealthCheck()

  return (
    <Grid container>
      {!withoutRedirect && <RedirectButton />}
      <>{isTablet ? <ListView items={data} /> : <TableView items={data} />}</>
    </Grid>
  )
}
